import BaiduConvertService from 'Map/utils/BadiuConvertService.js';
import { isChinaUser } from 'utils/ChinaUtil';

export default {
    getCurrentPosition: function(successCallback, errorCallback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function(position) {
                    if (successCallback) {
                        if (isChinaUser()) {
                            let convertService = new BaiduConvertService();
                            let convertedPosition = { coords: {} };
                            convertService.fetch(
                                {
                                    inputPoints: [
                                        {
                                            latitude: position.coords.latitude,
                                            longitude: position.coords.longitude
                                        }
                                    ],
                                    success: function(obj) {
                                        if (obj && obj.points) {
                                            convertedPosition.coords.latitude = Number(obj.points[0].lat);
                                            convertedPosition.coords.longitude = Number(obj.points[0].lng);
                                        }
                                        successCallback(convertedPosition);
                                    },
                                    error: function(response) {
                                        console.log(response);
                                    }
                                },
                                this
                            );
                        } else {
                            successCallback(position);
                        }
                    }
                },
                function() {
                    if (errorCallback) {
                        errorCallback();
                    }
                }
            );
        }
    },

    isValidLatitude: function(lat) {
        // 90 to -90
        return this.isNumber(lat) && lat !== 0 && lat >= -90 && lat <= 90;
    },

    isValidLongitude: function(lon) {
        // 180 and -180
        return this.isNumber(lon) && lon !== 0 && lon >= -180 && lon <= 180;
    },

    isNumber: function(val) {
        return typeof val === 'number';
    }
};
